import { FC } from 'react'
import { Listing, SearchListingsQuery } from 'graphql/types'
import Loader from 'components/Loader'
import RelatedListings from 'components/RelatedListings'
import { getAllRelatedListingsEvents } from 'components/RelatedListings/events'
import Typography from 'components/Typography'
import styles from './RecommendationsCarousel.module.scss'

export type TProps = {
  recommendations?: SearchListingsQuery['searchListings'] | null
  isLoading?: boolean
}

const RecommendationsCarousel: FC<TProps> = ({
  recommendations,
  isLoading,
}) => {
  if (isLoading) return <Loader />

  if (!recommendations?.listings?.length) return null

  return (
    <div className={styles.ecSearchRecommendationsCarousel}>
      <Typography
        as="h2"
        variant="Title"
        bold
        className={styles.ecSearchRecommendationsCarouselTitle}
      >
        Recomendações para você
      </Typography>
      <RelatedListings
        listings={recommendations.listings as Array<Listing>}
        listingCount={Math.min(recommendations?.totalCount as number, 15)}
        type="recommendations"
        {...getAllRelatedListingsEvents({
          origin: 'search',
          bannerType: 'recommendations',
        })}
      />
    </div>
  )
}

export default RecommendationsCarousel
